import Vue, {computed, getCurrentInstance} from "vue";

export const useContext = () => {
  const vm = getCurrentInstance()?.proxy;

  if (!vm)
    throw new Error("This must be called within a setup function.");

  const root = vm.$root;

  return {
    ...(Vue.prototype),
    ...(root),
    ...(vm),
    currentInstance: vm,
    route: computed(() => root.$route),
    query: computed(() => root.$route.query),
    params: computed(() => root.$route.params),
    $router: root.$router,
    $route: root.$route,
    $i18n: root.$i18n,
    $lang: root.$lang,
  };
};
